// Copyright (C) 2021 TANNER AG

import React, { useEffect } from "react";
import { compose, withProps } from "recompose";
import withConnectionStatus from "../hocs/withConnectionStatus";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import withLocalization from "../hocs/withLocalization";
import withErrorState from "../hocs/withErrorState";
import withPageInfo from "../hocs/withPageInfo";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { sharedComponentStyles } from "../screens/Component";
import Navigation from "../layouts/Navigation";
import EMobilityTopicIntro from "./EMobilityTopicIntro";
import withEMobilityChapter from "../hocs/withEMobilityChapter";
import EMobilityContent from "./EMobilityContent";
import EMobilityToc from "./EMobilityToc";
import ActionLink from "./ActionLink";
import { useHashLink } from "./usehashscroll";

const styles = (theme) => ({
    containerStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
    },
    heading: {
        marginTop: 24,
        marginBottom: 32,
    },
});

const EMobilityChapter = ({ classes, setPageInfo, eMobilityChapter, location }) => {
    const executeHashScroll = useHashLink();
    const number = `${eMobilityChapter.eMobilityTopic.order}.${eMobilityChapter.order}`;

    useEffect(() => {
        if (location.hash) {
            executeHashScroll(location.hash.substring(1));
        }
    }, [location.hash]);

    useEffect(() => {
        setPageInfo({ title: eMobilityChapter.title, parentTitle: eMobilityChapter.eMobilityTopic.title });
    }, [eMobilityChapter.title, eMobilityChapter.eMobilityTopic.title]);

    return (
        <React.Fragment>
            <Navigation />
            <div className={classes.mainWrapperStyle}>
                <EMobilityTopicIntro
                    kicker={eMobilityChapter.eMobilityTopic.title.toUpperCase()}
                    title={eMobilityChapter.title}
                    number={number}
                    description={eMobilityChapter.intro}
                    sideNode={<EMobilityToc chapter={eMobilityChapter} />}
                >
                    {eMobilityChapter.eMobilityContents &&
                        eMobilityChapter.eMobilityContents
                            .filter((content) => content.title)
                            .map((content, index) => {
                                const contentNumber = `${number}.${content.order}`;
                                return (
                                    <ActionLink key={index} href={`#chapter-${contentNumber}`} number={contentNumber}>
                                        {content.title}
                                    </ActionLink>
                                );
                            })}
                </EMobilityTopicIntro>
                <div className={classes.sectionsWrapperStyle}>
                    <EMobilityContent eMobilityContents={eMobilityChapter.eMobilityContents} number={number} />
                </div>
            </div>
        </React.Fragment>
    );
};

export default compose(
    withProps(({ match: { params } }) => {
        return {
            slug: params.slug,
        };
    }),
    withConnectionStatus,
    withGeneralTranslations,
    withLocalization,
    withErrorState,
    withEMobilityChapter(),
    withPageInfo,
    withRouter,
    withStyles(sharedComponentStyles),
    withStyles(styles)
)(EMobilityChapter);



// WEBPACK FOOTER //
// ./src/emobility/EMobilityChapter.js